import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { FormElement } from '@app/modules/form-generator/edit-form-v3/models/form.model';
import { PagedData } from '@app/modules/lookup/models/paged-data.model';
import { ReportType } from '@app/modules/report-designer/models/report-designer.model';
import { ReportDesignerService } from '@app/modules/report-designer/services/report-designer.service';
import { from, Observable } from 'rxjs';

@Component({
  selector: 'app-report-type-form-field',
  templateUrl: './report-type-form-field.component.html',
  styleUrls: ['./report-type-form-field.component.scss']
})
export class ReportTypeFormFieldComponent {
  @Input() formElement: FormElement;
  @Input() parentGroup: UntypedFormGroup;
  @Input() readOnly: boolean;
  isLoading: boolean;
  user$: any;
  filterString: string;
  options: Observable<PagedData<ReportType>>;

  constructor(
    private reportDesignerService: ReportDesignerService,
  ) { }

  ngOnInit(): void {
    this.options = from(this.reportDesignerService.getReportTypes(100, 0))
  }
}